import axios from "../config/axios-config";
/* eslint-disable import/prefer-default-export */

const fetchAuditHistory = async (data, token) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token.accessToken}`;
  const response = await axios.post("/api/audit/retrieve", data);
  const responseData = await response.data;
  return { results: responseData };
};

const fetchAuditUsers = async (data, token) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token.accessToken}`;
  const response = await axios.post("/api/audit/users", data);
  const responseData = await response.data;
  return { results: responseData.users };
};

export const auditApi = {
  fetchAuditHistory,
  fetchAuditUsers,
};
